import React from 'react'

export const PageLoader = () => {
  return (
    <div className='page-loader'><img src="../img/logo.gif" alt="page loader" /></div>
  )
}

export default PageLoader